import { useThunkDispatch } from 'store/hooks'
import { Notice, Severity, addNotification } from 'widget/Notifications'

// Добавление уведомления
export const useSetNotice = () => {
  const thunkDispatch = useThunkDispatch()

  const updateNotice = (text: string, severity: Severity) => {
    const notice: Notice = {
      text: text,
      severity: severity,
    }

    thunkDispatch(addNotification(notice))
  }

  return updateNotice
}
